import script from "./admin_meeting.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_meeting.vue?vue&type=script&setup=true&lang=js"

import "./admin_meeting.vue?vue&type=style&index=0&id=4cc1b9d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc1b9d1"]])

export default __exports__